import { useItem } from './hooks/use-context';

export function Pictures() {
  const { sections } = useItem();

  const questions = sections.flatMap((section) => section.questions);

  return (
    <div
      style={{
        paddingTop: '30px',
        marginTop: '20px',
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
      }}
    >
      <div
        style={{
          backgroundColor: '#FFFFFF',
          padding: '10px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          minHeight: '120px',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            border: '1px solid #69CC8D',
            borderRadius: '5px',
            backgroundColor: '#E0F4E9',
            padding: '6px',
            minHeight: '24px',
            justifyContent: 'space-between',
            textAlign: 'center',
          }}
        >
          REGISTRO FOTOGRÁFICO - Imagens do Local do Acidente
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '1rem',
            padding: '1rem',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {questions
            .find(
              (question) =>
                question.question_id === '9e690e85-b7e3-4254-a2df-f9d1b572b04f',
            )
            ?.answers.map(
              (answer) =>
                answer.content && (
                  <div
                    key={answer.id}
                    style={{
                      overflow: 'hidden',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <img
                      style={{
                        objectFit: 'contain',
                        width: '100%',
                        height: '100%',
                        maxHeight: '300px',
                      }}
                      src={`${answer.content || ''}`}
                      alt="img"
                    />
                  </div>
                ),
            )}
        </div>
      </div>
    </div>
  );
}
